import React from "react";

// Renders a human avatar image when `src` is a URL, else falls back to an emoji (legacy chars).
export default function Avatar({ src, size = 44, className = "", ring, idle }) {
  const isImg = typeof src === "string" && src.startsWith("http");
  const style = { width: size, height: size };
  const ringStyle = ring ? { boxShadow: `0 0 0 2px ${ring}` } : {};
  const idleCls = idle ? "avatar-idle" : "";
  if (isImg) {
    return (
      <img
        src={src}
        alt="avatar"
        loading="lazy"
        style={{ ...style, ...ringStyle }}
        className={`rounded-full object-cover bg-[#1A1A1A] shrink-0 ${idleCls} ${className}`}
      />
    );
  }
  return (
    <div
      style={{ ...style, ...ringStyle, fontSize: size * 0.6 }}
      className={`rounded-full bg-[#1A1A1A] flex items-center justify-center shrink-0 ${idleCls} ${className}`}
    >
      {src || "🧑🏾"}
    </div>
  );
}
